// extracted by mini-css-extract-plugin
export var banner = "_4-0";
export var icon = "_4-1";
export var message = "_4-2";